import {
  GET_PLC_SAFETY_DASHBOARD_STATS,
  GET_PLC_SAFETY_DASHBOARD_STATS_SUCCESS,
  GET_PLC_SAFETY_DASHBOARD_STATS_ERROR,
} from './actionTypes';

export const getPlcSafetyDashboardStats = (user) => {
  return {
    type: GET_PLC_SAFETY_DASHBOARD_STATS,
    payload: { user },
  };
};

export const getPlcSafetyDashboardStatsSuccess = (stats, message) => {
  return {
    type: GET_PLC_SAFETY_DASHBOARD_STATS_SUCCESS,
    payload: { stats, message },
  };
};

export const getPlcSafetyDashboardStatsError = (msg) => {
  return {
    type: GET_PLC_SAFETY_DASHBOARD_STATS_ERROR,
    payload: msg,
  };
};
